import { _ as __assign } from './chunks/bundle-C7jYHvwG.js';
import React__default from 'react';
import CreateChannel$1 from './CreateChannel/components/CreateChannelUI.js';
import { C as CreateChannelProvider } from './chunks/bundle-CHzQIw7_.js';
import './CreateChannel/components/InviteUsers.js';
import './chunks/bundle-CIN9yQRB.js';
import './chunks/bundle-pOZPN8hk.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-DfDrbjM5.js';
import './chunks/bundle-MyLy9AIu.js';
import './chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-CDjVXDOc.js';
import './chunks/bundle-Dl9NVsui.js';
import './chunks/bundle-DkviGBGz.js';
import './chunks/bundle-DUTyBaXr.js';
import 'react-dom';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-DImSV9VW.js';
import './ui/Icon.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-CLonR-iH.js';
import './chunks/bundle-C6-Ix-Lk.js';
import './ui/SortByRow.js';
import './ui/UserListItem.js';
import './chunks/bundle-gQ2a8Eki.js';
import './chunks/bundle-CbEyAimK.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-BR3O1lZq.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './chunks/bundle-MkyS3j4-.js';
import './CreateChannel/components/SelectChannelType.js';

var CreateChannel = function (props) {
    return (React__default.createElement(CreateChannelProvider, __assign({}, props),
        React__default.createElement(CreateChannel$1, __assign({}, props))));
};

export { CreateChannel as default };
//# sourceMappingURL=CreateChannel.js.map
